import React from "react";
import { ListWrapper} from "../ui/Catalog";
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import {profilePipe} from "../repository";
import DetailsProduct from "../ui/Catalog/DetailsProducts";


const PipeController = (props) => {
    return <div>
        {!props.match.params.id
            ? <ListWrapper {...props} url={'profilePipe'}/>
            : <DetailsProduct products={profilePipe} id={props.match.params.id}/>}
    </div>
};

const mapState = (state) => {
   return {
       data: state.catalogPage.profilePipe
   }
};

export default withRouter(connect(mapState, null)(PipeController))
